<template>
  <div class="autocomplete-container">
    <IconField iconPosition="left">
    <AutoComplete
        id="global-search"
        v-model="searchQuery"
        :suggestions="autoCompleteResults"
        @complete="getSearchResults"
        @itemSelect="onSelect($event)"
        placeholder="Search Slides"
        style="font-size: 14px;"
        field="label"
        @keyup.enter="goToSearchResults"
    >
      <template #option="{option}">
        <div>{{ option.label }}</div>
        <div style="font-size: 12px; color: #757575;">Published by: {{ option.authorName}}</div>
        <div style="font-size: 12px; color: #757575;">Value Model: {{ option.valueModelName }}</div>
      </template>
    </AutoComplete>
      <InputIcon class="pi pi-search"> </InputIcon>
    </IconField>


  </div>
</template>

<script setup  lang="ts">
import {useRouter} from 'vue-router'
import { useSearch } from "@/hooks/useSearchService";


const router = useRouter();

const { searchQuery, autoCompleteResults, getSearchResults } = useSearch();


const onSelect = (event) => {

  router.push({name: 'editor', query: {id: event.value.value, vmId: event.value.vmId}})
}

const goToSearchResults = () => {
  if (searchQuery.value.trim() === "") return;
  router.push({  path: '/search', query: { q: searchQuery.value } });
};

</script>

<style>
#global-search .p-inputtext {
  padding-left: 35px;
  border-radius: 5px;
  width: 1152px;
}


</style>

<style lang="scss" scoped>




</style>
